export const hasNumber = (myString) => {
    return /\d/.test(myString);
};

export const hasUpper = (str) => {
    return /[A-Z]/.test(str);
};

export const hasSpecialchar = (str) => {
    return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(str);
};